import { requestFromServer } from './api-client';

const WarehouseClient = {
  getBranchByWarehouseUser: async (userId) => {
    return requestFromServer(`v1/Warehouse/getBranchByWarehouseUser/${userId}`);
  },
};

export default WarehouseClient;
